import { createBrowserRouter } from "react-router-dom";
import { MAIN_ROUTER_CONFIG } from "./MainRouterConfig";

/**
 * This is the recommended router for all React Router web projects.
 */

export const ROUTER = createBrowserRouter(MAIN_ROUTER_CONFIG);
